import React, { useState } from "react";
import PropTypes from "prop-types";

import { FieldValue, serverTimestamp } from "firebase/firestore";
import { db } from "../../lib/firebaseCompat";

import { useTooltip } from "../../hooks/useTooltip";

export default function EstimateTdDownload({ docId, orgId }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = (template) => {
    return async (evt) => {
      if (!orgId || !docId) {
        return;
      }

      setLoading(true);

      const doc = db
        .collection("organizations")
        .doc(orgId)
        .collection("estimates")
        .doc(docId)
        .collection("pdfRequests")
        .doc();

      try {
        console.log(template, orgId, docId);
        const now = serverTimestamp();
        await doc.set({
          createdAt: now,
          updatedAt: now,
          template,
        });

        const unsubscribe = doc.onSnapshot((snap) => {
          const { url } = snap.data();
          if (!url) {
            return;
          }
          console.log("url to open", url);
          unsubscribe();
          setLoading(false);
          window.open(url, "_blank");
        });
      } catch (err) {
        console.error(err);
      }
    };
  };

  const DownloadLinks = () => {
    const refA = useTooltip();
    const refB = useTooltip();
    return (
      <>
        <td>
          <i
            className="material-icons cursor-pointer secondary-text-color"
            data-tooltip="Download Itemized PDF"
            data-position="left"
            ref={refA}
            onClick={handleDownload("cavs_itemized_09_04_2019.pdf")}
          >
            description
          </i>
        </td>
        <td>
          <i
            className="material-icons cursor-pointer secondary-text-color"
            data-tooltip="Download Summary PDF"
            data-position="left"
            ref={refB}
            onClick={handleDownload("cavs_summary_09_04_2019.pdf")}
          >
            insert_drive_file
          </i>
        </td>
      </>
    );
  };

  const LoadingBar = () => {
    return (
      <td colSpan={2}>
        <div className="progress">
          <div className="indeterminate"></div>
        </div>
      </td>
    );
  };

  return loading ? <LoadingBar /> : <DownloadLinks />;
}

EstimateTdDownload.propTypes = {
  orgId: PropTypes.string.isRequired,
  docId: PropTypes.string.isRequired,
};
